import { Box } from 'pcln-design-system'
import { type ReactNode } from 'react'
import { PrimaryWrapper, SecondaryWrapper, TertiaryWrapper } from './AdBox.styled'

const AdBoxWrapper = {
  primary: PrimaryWrapper,
  secondary: SecondaryWrapper,
  tertiary: TertiaryWrapper,
}

export default function AdBox({ children, type }: { children?: ReactNode; type: keyof typeof AdBoxWrapper }) {
  const Wrapper = AdBoxWrapper[type]
  return (
    <Wrapper>
      <Box width={1}>{children}</Box>
    </Wrapper>
  )
}
